export default "__VITE_ASSET__Uro2VxVp__"